import { ApiRequestConfig, apiService } from './api.service';

import { IRefreshSessionResponse } from '@/interfaces/auth/IRefreshSessionResponse';
import { ISignInResponse } from '@/interfaces/auth/ISignInResponse';
import { ISignUpResponse } from '@/interfaces/auth/ISignUpResponse';
import { ISuccessfulAuthenticationResponse } from '@/interfaces/auth/ISuccessfulAuthenticationResponse';
import { IApiService } from '@/interfaces/services/IApiService';
import { IAuthService } from '@/interfaces/services/IAuthService';

class AuthService implements IAuthService {
	api: IApiService<ApiRequestConfig>;
	constructor(api: IApiService<ApiRequestConfig>) {
		this.api = api;
	}
	async signIn(
		username: string,
		password: string,
		signUpAsConsumer?: boolean,
		config?: ApiRequestConfig,
	) {
		return await this.api.post<ISignInResponse>(
			'/auth/sign-in',
			{ username, password, signUpAsConsumer },
			config,
		);
	}
	async signUp(
		username: string,
		password: string,
		signUpAsConsumer?: boolean,
		config?: ApiRequestConfig,
	) {
		return await this.api.post<ISignUpResponse>(
			'/auth/sign-up',
			{ username, password, signUpAsConsumer },
			config,
		);
	}
	async confirmUser(username: string, code: string, config?: ApiRequestConfig) {
		return await this.api.post<ISuccessfulAuthenticationResponse>(
			'/auth/confirm-user',
			{ username, code },
			config,
		);
	}
	async confirmPassword(
		username: string,
		newPassword: string,
		code: string,
		config?: ApiRequestConfig,
	) {
		return await this.api.post<ISuccessfulAuthenticationResponse>(
			'/auth/confirm-password',
			{ username, newPassword, code },
			config,
		);
	}
	async resendConfirmationCode(username: string, config?: ApiRequestConfig) {
		return await this.api.post<ISuccessfulAuthenticationResponse>(
			'/auth/resend-confirmation-code',
			{ username },
			config,
		);
	}
	async forgotPassword(username: string, config?: ApiRequestConfig) {
		return await this.api.post<ISuccessfulAuthenticationResponse>(
			'/auth/forgot-password',
			{ username },
			config,
		);
	}
	async refreshToken(
		username: string,
		refreshToken: string,
		config?: ApiRequestConfig,
	) {
		return await this.api.post<IRefreshSessionResponse>(
			'/auth/refresh',
			{ username, refreshToken },
			config,
		);
	}

	async confirmInvite(email: string, otp: string, password: string) {
		const body = {
			email,
			otp,
			password,
			userId: 0, // If needed, replace with actual user ID if stored
		};
		return await this.api.post<{ message: string }>(
			'/user/confirm-invite',
			body,
		);
	}
}

export const authService = new AuthService(apiService);
